import { ServiceRequestModule } from '../service-request/service-request.module';
import {AmenitiesModule} from '../amenities/amenities.module';
import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { DocumentsModule } from '../documents/documents.module';
import { PassOnLogModule } from '../pass-on-log/pass-on-log.module';
import { ParcelsModule } from '../parcels/parcels.module';
import { IncidentReportsModule } from '../incident-reports/incident-reports.module';
import { KeyLogModule } from '../key-log/key-log.module';
import { DailyReportsModule } from '../daily-reports/daily-reports.module';
import { EmailModule } from '../email/email.module';
import { AdminModule } from '../admin/admin.module';
import { OrderModule } from '../../pipes/orderPipe/pipe.module';
import { ParkingPassModule } from '../parking-pass/parking-pass.module';
import {FavoriteServicesComponent} from 'app/views/home/favorite-services/favorite-services.component';
import {NewsListComponent} from './news-list/news-list.component';
import { AddInstructionsModalModule } from 'app/components/directory/add-instructions-modal/add-instructions-modal.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';

@NgModule({
    declarations: [
        HomeComponent,
        FavoriteServicesComponent,
        NewsListComponent,
    ],

    imports: [
        CommonModule,
        AmenitiesModule,
        ServiceRequestModule,
        DocumentsModule,
        BrowserModule,
        IncidentReportsModule,
        ParcelsModule,
        PassOnLogModule,
        DailyReportsModule,
        KeyLogModule,
        EmailModule,
        HttpModule,
        OrderModule,
        AdminModule,
        ParkingPassModule,
        AddInstructionsModalModule,
        AngularMaterialImportModule
    ],

})
export class HomeModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/home/home.module.ts